var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Premios_-_sistema_-_arquitetos_-_celular",
    "data-name": "Premios - sistema - arquitetos - celular",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.447,
    height: 29.447,
    viewBox: "0 0 29.447 29.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M419.734,261.165l3.407-1.792,3.407,1.792-.651-3.794,2.756-2.687-3.809-.553-1.7-3.453-1.7,3.453-3.809.553,2.756,2.687Zm2.73-5.621.677-1.371.677,1.371,1.513.22-1.1,1.068.259,1.508-1.354-.712-1.354.712.259-1.508-1.1-1.068Z",
    transform: "translate(-408.308 -246.441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M409.221,250.592a4.314,4.314,0,0,0,0,8.627h1.224a9.558,9.558,0,0,0,6.6,6.547v3.8h-3.212l-1.726,5.234h-1.964v1.725h18.98v-1.725h-1.965l-1.725-5.234h-3.212v-3.81a9.528,9.528,0,0,0,6.543-6.543h1.279a4.314,4.314,0,0,0,0-8.627h-.92V248.81H430.9v-1.726H408.358v1.726h1.725v1.783Zm0,6.9a2.588,2.588,0,0,1,0-5.176h.862v4.314c0,.29.014.578.04.862Zm16.119,17.312H413.922l1.156-3.509h9.105Zm-4.846-5.234h-1.726v-3.49c.284.025.572.039.863.039s.578-.014.863-.04Zm9.547-17.254a2.588,2.588,0,0,1,0,5.176h-.96c.026-.284.04-.572.04-.862v-4.314ZM427.4,248.81v7.822a7.793,7.793,0,0,1-15.586,0V248.81Z",
    transform: "translate(-404.907 -247.084)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.9d7a94f1fed370c165ea9809dabc7fd9.svg";
export { ForwardRef as ReactComponent };